export default "__VITE_ASSET__B5IB4Ue4__"